import { useState } from "react";
import clsx from "clsx";
import { useTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import MenuNavegacion from "./Componentes/Menu";
import BarraSuperior from "./Componentes/AppBar";
import styles from "./styles";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getPermisosCuenta, getProfileAction } from "../../ducks/logeoDuck";

export default function HomePage({ children }) {
  const classes = styles();
  const theme = useTheme();
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false);
  useEffect(() => {
    dispatch(getPermisosCuenta())
    dispatch(getProfileAction())
  }, [dispatch])
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  return (
    <div className={classes.root}>
      <CssBaseline />
      <BarraSuperior
        classes={classes}
        handleDrawerOpen={handleDrawerOpen}
        open={open}
      />
      <MenuNavegacion
        open={open}
        classes={classes}
        theme={theme}
        handleDrawerClose={handleDrawerClose}
      />
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <div className={classes.drawerHeader}></div>
        {children}
      </main>
    </div>
  );
}
